// src/services/api.js
import axios from 'axios';

//l'url de backend django — relative pour passer par le reverse proxy (même origine)
const API_URL = '/api/';

//creation d'une instance axios 
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json', // on envoie des données en json
  },
});

// Intercepteur de requête : ajoute le token JWT

api.interceptors.request.use(
  // Ajoute un intercepteur pour les requêtes sortantes (avant envoi).
  (config) => {
    // Fonction de succès : reçoit la configuration de la requête.
    const accessToken = localStorage.getItem('access_token');
    // Récupère le token JWT stocké dans le localStorage sous la clé 'access_token'.
    if (accessToken) {
      // Si un token existe (non null et non vide)...
      config.headers.Authorization = `Bearer ${accessToken}`;
      // ...ajoute l'en-tête Authorization avec la valeur "Bearer <token>" à la requête.
    }
    return config;
    // Retourne la configuration modifiée pour que la requête puisse continuer.
  },
  (error) => Promise.reject(error)
  // Fonction d'erreur : en cas d'échec de l'intercepteur, on rejette la promesse avec l'erreur.
);


// Intercepteur de réponse : rafraîchit le token si 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}token/refresh/`, {
            refresh: refreshToken,
          });
          const { access } = response.data;
          localStorage.setItem('access_token', access);
          originalRequest.headers.Authorization = `Bearer ${access}`;
          return api(originalRequest);
        } catch (refreshError) {
          // Refresh invalide → déconnexion
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          window.location.href = '/';
          return Promise.reject(refreshError);
        }
      } else {
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;